module.exports = __webpack_public_path__ + "img/9-4.8b987e40.jpg";